import { Users } from '@omnea-app/packages/universal/hasura/graphql'
import { InitialsAvatar, InitialsAvatarProps } from './InitialsAvatar'

interface Props extends Pick<InitialsAvatarProps, 'size' | 'sx'> {
  user: Pick<Users, 'id' | 'firstName' | 'lastName'>
}

export const LoggedInUserAvatar: React.FC<Props> = ({ user, ...rest }) => {
  const name = `${user.firstName ?? ''} ${user.lastName ?? ''}`
  return <InitialsAvatar fullName={name} colourSubjectId={user.id} {...rest} />
}

interface UserAvatarProps extends Pick<InitialsAvatarProps, 'size' | 'sx'> {
  user: Pick<Users, 'id' | 'firstName' | 'lastName' | 'isArchived'>
}

export const UserAvatar: React.FC<UserAvatarProps> = ({ user, ...rest }) => {
  const name = `${user.firstName ?? ''} ${user.lastName ?? ''}`
  return <InitialsAvatar fullName={name} colourSubjectId={user.id} isArchived={user.isArchived} {...rest} />
}
